import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRuler = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.755 20.097 9.341-9.343a3.083 3.083 0 0 0 0-4.36l-2.49-2.491a3.086 3.086 0 0 0-4.361 0l-9.342 9.342a3.083 3.083 0 0 0 0 4.36l2.49 2.492a3.084 3.084 0 0 0 4.362 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m12.684 4.463 3.083 3.083M4.463 12.686l2.399 2.398M7.236 9.911l3.05 3.116M9.944 7.203l1.712 1.713"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRuler);
export default ForwardRef;
